import { Fragment, useEffect, useRef } from 'react';
import { useMe } from '@crehana/auth';
import { getUserDistinctId, parseQueryStrings } from '@crehana/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export function register(_ref) {
  var user = _ref.user,
    countryPrefix = _ref.countryPrefix,
    countryCode = _ref.countryCode;
  if (typeof window === 'undefined') {
    return;
  }
  var _getUserDistinctId = getUserDistinctId(),
    distinctId = _getUserDistinctId.distinctId;
  var queryParams = parseQueryStrings(window.location.search);
  var _document = document,
    referrer = _document.referrer;
  var payload = {
    query_params: queryParams,
    url: window.location.href,
    user_id: user === null || user === void 0 ? void 0 : user.originalId,
    distinct_id: distinctId,
    referrer: referrer,
    iso: countryCode || countryPrefix || ''
  };
  var isDirect = !referrer;
  var isOrganic = referrer && !referrer.includes('crehana.com') && !referrer.includes('creha.co') && !referrer.includes('localhost') && !referrer.includes('127.0.0.1');
  var forceSend = !!(queryParams !== null && queryParams !== void 0 && queryParams.forceChannelRegister);
  if (isDirect || isOrganic || forceSend) {
    fetch('/api/v3/channel-register/', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(payload)
    }).then(function () {})["catch"](function (error) {});
  }
}

// channels
export var Channels = function Channels(_ref2) {
  var children = _ref2.children,
    countryPrefix = _ref2.countryPrefix,
    countryCode = _ref2.countryCode;
  // ref used to only send the track one time
  var done = useRef(false);
  var _useMe = useMe(),
    me = _useMe.me,
    loading = _useMe.loading,
    error = _useMe.error;
  useEffect(function () {
    if (!loading && !error && !done.current) {
      done.current = true;
      register({
        user: me,
        countryCode: countryCode || countryPrefix || ''
      });
    }
  }, [loading, me, error, countryCode, countryPrefix]);
  return /*#__PURE__*/_jsx(Fragment, {
    children: children
  });
};
export default Channels;